<template>
  <div class="catalog-save-filter-modal">
    <ModalComponentHeader>
      {{ messages?.newFiltersSet }}
    </ModalComponentHeader>
    <ModalComponentBody>
      <!--      {{ filterName }}-->
      <form class="save-filter-form" @submit.prevent="handlerSaveFilter">
        <DefInput
          v-model="filterName"
          :placeholder="messages?.name"
          required
          :is-error="isError"
          :is-show-error="isError"
          :error-text="responseText"
        />
        <DefButtonPrimary type="submit">{{ messages?.save }}</DefButtonPrimary>
      </form>
    </ModalComponentBody>
  </div>
</template>

<script lang="ts" setup>
import ModalComponentHeader from '@use/useModal/ModalComponentHeader.vue';
import ModalComponentBody from '@use/useModal/ModalComponentBody.vue';
import DefInput from '@components/Def/DefInput/DefInput.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import { useStore } from '@/store';
import { computed, ref } from 'vue';
import useModal from '@use/useModal/useModal';

const modal = useModal();

const { state, dispatch } = useStore();
const messages = computed(() => state?.catalog?.data?.catalogSmartFilter?.messages);

const isError = ref(false);
const responseText = ref('');

const filterName = ref('');
const handlerSaveFilter = async () => {
  const response = await dispatch('catalog/addUserCatalogFilter', {
    filterName: filterName.value,
  });

  if (response.data.response.status === false) {
    responseText.value = response.data.response.text;
    isError.value = true;
  } else if (response.data.response.status === true) {
    modal.hide();
  }
  console.log('save end!!!');
};
</script>

<style lang="scss" scoped>
.catalog-save-filter-modal {
}
.save-filter-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-row-gap: 16px;
  @include point-lg {
    grid-row-gap: 24px;
  }
}
</style>
